import { send } from '../../../../../../../src/network';

type DeleteFavoriteProductResponse = unknown;

type DeleteFavoriteProductParams = {
  customerId: number;
  productId: number;
};

export function deleteFavoriteProductPath({
  customerId,
  productId,
}: DeleteFavoriteProductParams) {
  return `/api/v2/customers/${customerId}/favorite_products/${productId}/`;
}

export async function deleteFavoriteProduct({
  customerId,
  productId,
}: DeleteFavoriteProductParams) {
  return await send<DeleteFavoriteProductResponse>({
    path: deleteFavoriteProductPath({ customerId, productId }),
    method: 'DELETE',
  });
}
